import type { ImpersonationMode } from '../contexts/AuthContext';

export const IMPERSONATION_MODE_LABELS = {
  ghost: 'Ghost Mode',
  god: 'Super Ghost Mode',
} as const;

export const IMPERSONATION_MODE_DESCRIPTIONS = {
  ghost: 'Read-only access. Browse cases, drafts, and settings without making changes.',
  god: 'Full read/write access for support fixes. Document your reason before use.',
} as const;

export function getImpersonationModeLabel(mode: NonNullable<ImpersonationMode>): string {
  return IMPERSONATION_MODE_LABELS[mode];
}
